import ReactECharts from "echarts-for-react";
import { useLanguage } from "../../../components/contexts/LanguageContext"; 
import translations from "../../../components/translations"; 


const Humidity = () => {
    const { selectedLanguage } = useLanguage(); 
    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'line',
                label: {
                    backgroundColor: '#6a7985',
                },
            },
        },
        grid: {
            top: '5%',
            left: '1.5%',
            right: '2%',
            bottom: '5%',
            containLabel: true,
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            axisTick: {
                alignWithLabel: true,
            },
            data: ["Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez", "Jan", "Fev"]
        },
        yAxis: {
            type: "value",
            min: 0,
            max: 40,
            axisLabel: {
                formatter: "{value}°"
            }
        },
        series: [
            {
                name: `${translations[selectedLanguage].dailyMinimum}`,
                type: "line",
                data: [22, 20, 18, 17, 15, 16, 18, 20, 22, 24, 25, 26],
                color: "#007bff"
            },
            {
                name: `${translations[selectedLanguage].dailyMaximum}`,
                type: "line",
                data: [32, 30, 29, 28, 27, 28, 30, 32, 33, 34, 35, 36],
                color: "#ff4d4d"
            },
            {
                name: `${translations[selectedLanguage].dayForecast30}`,
                type: "line",
                data: [null, null, null, null, null, null, null, null, null, null, 28, 29],
                lineStyle: {
                    type: "dotted"
                },
                color: "#ff4d4d"
            },
            {
                name: `${translations[selectedLanguage].dailyHistoricalTemperature}`,
                type: "line",
                data: [26, 25, 24, 23, 22, 23, 24, 25, 26, 27, 28, 29],
                lineStyle: {
                    type: "dashed"
                },
                color: "#000"
            }
        ]
    };

    return <ReactECharts option={option} style={{ height: "400px" }} />;
};

export { Humidity };